module.exports = __webpack_public_path__ + "static/media/prof default.fd82d0a0.png";